import React from "react";
import { Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

const PublicRouteWithLayout = (props) => {
  const { layout: Layout, component: Component, ...rest } = props;
  const token = localStorage.getItem("token");
  //props.history.push("/postit/dashboard");
  // if (token) {
  //   console.log(token, "this is token");
  //   props.history.push("/postit/dashboard");
  // }
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Layout>
          <Component {...matchProps} />
        </Layout>
      )}
    />
  );
};

PublicRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
};

export default withRouter(PublicRouteWithLayout);
